var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditUnderLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60186 1.09882L9.17488 0.516312C9.85209 -0.172104 11.0307 -0.172104 11.7079 0.516312L12.1702 0.986288C12.5088 1.3305 12.6977 1.78723 12.6977 2.27045C12.6977 2.75366 12.5088 3.21702 12.1702 3.55461L11.5972 4.13712L8.60186 1.0922V1.09882ZM7.91163 1.80047L1.97953 7.83073C1.7907 8.0227 1.67349 8.27423 1.65395 8.54563L1.47814 10.4851C1.4586 10.73 1.54326 10.9683 1.71256 11.147C1.86884 11.3059 2.0707 11.392 2.28558 11.392H2.35721L4.26512 11.2132C4.53209 11.1868 4.77954 11.0676 4.96837 10.8757L10.9005 4.84539L7.90512 1.80047H7.91163ZM14 13.5035C14 13.2322 13.7786 13.0071 13.5116 13.0071H0.488372C0.221395 13.0071 0 13.2322 0 13.5035C0 13.7749 0.221395 14 0.488372 14H13.5116C13.7786 14 14 13.7749 14 13.5035Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditUnderLine);
export default __webpack_public_path__ + "static/media/EditUnderLine.0b388ebe6d488edb2d0edea09ddcdb1f.svg";
export { ForwardRef as ReactComponent };